export const RESHIP = 'RESHIP';
export const REFUND = 'REFUND';
export const CUSTOM = 'CUSTOM';
export const STORE_CREDIT = 'STORE_CREDIT';
export const APPROVED = 'APPROVED';
export const DENIED = 'DENIED';
export const FLAT_RATE = 'FLAT_RATE';
export const FLAT_RATE_STORE_CREDIT = 'FLAT_RATE_STORE_CREDIT';
export const ClaimDocumentType = {
  SIGNATURE: 'SIGNATURE',
  ACKNOWLEDGEMENT: 'ACKNOWLEDGEMENT',
  RECEIPT: 'RECEIPT',
} as const;
export const defaultTrackingBaseUrl = 'https://www.aftership.com/track';
export const ORDER_ISSUES = {
  notReceived: 'notReceived',
  issuesWithItems: 'issuesWithItems',
};

export const ITEM_ISSUES = {
  damaged: 'DAMAGED',
  defective: 'DEFECTIVE_ITEM',
  missing: 'MISSING_ITEM',
  wrong: 'WRONG_ITEM',
};

export const SHIPMENT_ISSUES = {
  deliveredButNotReceived: 'ORDER_DELIVERED_NOT_RECEIVED',
  returnedToSender: 'RETURNED_TO_SENDER',
  stolen: 'STOLEN',
  trackingNotMoving: 'TRACKING_NOT_MOVING',
  wrongAddress: 'WRONG_ADDRESS',
};

export const SHIPMENT_ISSUES_TEXT = {
  stolen: 'My package was stolen',
  deliveredButNotReceived: "Order says it was delivered but I didn't receive it",
  returnedToSender: 'Returned to sender',
  trackingNotMoving: 'Tracking is not moving',
  wrongAddress: 'Wrong address',
};

export const DISPLAY_ITEM_ISSUES = {
  [ITEM_ISSUES.damaged]: 'Damaged',
  [ITEM_ISSUES.defective]: 'Defective',
  [ITEM_ISSUES.missing]: 'Missing',
  [ITEM_ISSUES.wrong]: 'Wrong item',
  [SHIPMENT_ISSUES.deliveredButNotReceived]: 'Order Delivered Not Received',
  [SHIPMENT_ISSUES.returnedToSender]: 'Returned to sender',
  [SHIPMENT_ISSUES.stolen]: 'Stolen',
  [SHIPMENT_ISSUES.trackingNotMoving]: 'Tracking not moving',
  [SHIPMENT_ISSUES.wrongAddress]: 'Wrong address',
};

export const ITEM_ISSUES_REQUIRING_IMAGES = [ITEM_ISSUES.damaged, ITEM_ISSUES.defective, ITEM_ISSUES.wrong];

export const ITEM_ISSUE_OPTIONS = [
  {
    label: 'Damaged',
    value: ITEM_ISSUES.damaged,
  },
  {
    label: 'Defective',
    value: ITEM_ISSUES.defective,
  },
  {
    label: 'Missing',
    value: ITEM_ISSUES.missing,
  },
  {
    label: 'Wrong item',
    value: ITEM_ISSUES.wrong,
  },
];

export const ORDER_RESOLUTIONS = {
  refund: 'REFUND',
  reship: 'RESHIP',
  storeCredit: 'STORE_CREDIT',
};

export const DISPLAY_ORDER_RESOLUTIONS = {
  [ORDER_RESOLUTIONS.refund]: 'Refund',
  [ORDER_RESOLUTIONS.reship]: 'Reshipment',
  [ORDER_RESOLUTIONS.storeCredit]: 'Store Credit',
};

export const CommonErrors = {
  SignatureUploadError: 'Signature upload unsuccessful. Please try again.',
  UnknownError: 'An unknown error occurred. Please try again later.',
};

export const CLAIM_MEDIA_TYPE = 'CLAIM';

export const CREDIT_BONUS_TYPES = {
  fixed: 'fixed',
  percentage: 'percentage',
};

export const ClaimState = {
  APPROVED: 'APPROVED',
  DENIED: 'DENIED',
};
export const WARRANTY_ITEM_ISSUE_OPTIONS = [
  {
    label: 'Damaged',
    value: ITEM_ISSUES.damaged,
  },
  {
    label: 'Defective',
    value: ITEM_ISSUES.defective,
  },
];
export const ClaimCategory = {
  SHIPPING: 'SHIPPING',
  WARRANTY: 'WARRANTY',
};

export const SalesChannel = {
  IN_STORE: 'IN_STORE',
  ONLINE: 'ONLINE',
};

export const ExternalSalesChannel = {
  AMAZON: 'AMAZON',
  COSTCO: 'COSTCO',
  OTHER: 'OTHER',
  TIKTOK_SHOP: 'TIKTOK_SHOP',
};

export const EXTERNAL_SALES_CHANNEL_LABELS: Record<string, string> = {
  AMAZON: 'Amazon',
  COSTCO: 'Costco',
  OTHER: 'Other',
  TIKTOK_SHOP: 'TikTok Shop',
};

export const CLAIM_TYPES = [
  'STOLEN',
  'DAMAGED',
  'DEFECTIVE_ITEM',
  'ORDER_DELIVERED_NOT_RECEIVED',
  'WRONG_ITEM',
  'MISSING_ITEM',
  'RETURNED_TO_SENDER',
  'TRACKING_NOT_MOVING',
  'WRONG_ADDRESS',
] as const;
